module.exports = __webpack_public_path__ + "resources/images/bunq-ac22593125f82074ed1670e66c6f9c66-cache.png";